import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _LineEndingMode___init__impl__jo5bul(mode) {
  return mode;
}
function _get_mode__dah3bc($this) {
  return $this;
}
function LineEndingMode__contains_impl_q5pr68($this, other) {
  return (_get_mode__dah3bc($this) | _get_mode__dah3bc(other)) === _get_mode__dah3bc($this);
}
function LineEndingMode__plus_impl_ttpz2j($this, other) {
  return _LineEndingMode___init__impl__jo5bul(_get_mode__dah3bc($this) | _get_mode__dah3bc(other));
}
function LineEndingMode__toString_impl_j4h76r($this) {
  var tmp;
  if ($this === Companion_getInstance().u4l_1) {
    tmp = 'CR';
  } else if ($this === Companion_getInstance().v4l_1) {
    tmp = 'LF';
  } else if ($this === Companion_getInstance().w4l_1) {
    tmp = 'CRLF';
  } else {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = Companion_getInstance().y4l_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().p2();
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var it = element.z4l_1;
      if (LineEndingMode__contains_impl_q5pr68($this, it)) {
        destination.j2(element);
      }
    }
    tmp = toString(destination);
  }
  return tmp;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.u4l_1 = _LineEndingMode___init__impl__jo5bul(1);
        this.v4l_1 = _LineEndingMode___init__impl__jo5bul(2);
        this.w4l_1 = _LineEndingMode___init__impl__jo5bul(4);
        this.x4l_1 = _LineEndingMode___init__impl__jo5bul(7);
        this.y4l_1 = listOf([new (LineEndingMode())(this.u4l_1), new (LineEndingMode())(this.v4l_1), new (LineEndingMode())(this.w4l_1)]);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function LineEndingMode__hashCode_impl_2mopm4($this) {
  return $this;
}
function LineEndingMode__equals_impl_qyr4nk($this, other) {
  if (!(other instanceof LineEndingMode()))
    return false;
  if (!($this === other.z4l_1))
    return false;
  return true;
}
var LineEndingModeClass;
function LineEndingMode() {
  if (LineEndingModeClass === VOID) {
    class $ {
      constructor(mode) {
        Companion_getInstance();
        this.z4l_1 = mode;
      }
      toString() {
        return LineEndingMode__toString_impl_j4h76r(this.z4l_1);
      }
      hashCode() {
        return LineEndingMode__hashCode_impl_2mopm4(this.z4l_1);
      }
      equals(other) {
        return LineEndingMode__equals_impl_qyr4nk(this.z4l_1, other);
      }
    }
    initMetadataForClass($, 'LineEndingMode');
    LineEndingModeClass = $;
  }
  return LineEndingModeClass;
}
//region block: exports
export {
  LineEndingMode__plus_impl_ttpz2j as LineEndingMode__plus_impl_ttpz2j3u2ebrlepd29o,
  Companion_getInstance as Companion_getInstance33j3lym6q7yx7,
};
//endregion

//# sourceMappingURL=LineEndingMode.mjs.map
